import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';
import { NotificationsPanelComponent } from './notifications-panel/notifications-panel.component';
import { ShellComponent } from './shell/shell.component';
// for making API calls
import { HttpClientModule } from '@angular/common/http';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { JoyrideModule } from 'ngx-joyride';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { AddProvidersComponent } from '../dialogs/patient/add-providers/add-providers.component';
import { EMRSearchComponent } from '../dialogs/patient/emr-search/emr-search.component';
import { ScheduleMessageDialogComponent } from '../dialogs/practice/schedule-message-dialog/schedule-message-dialog.component';
import { MessageDialogComponent } from '../dialogs/practice/sms-message-dialog/message-dialog.component';
import { RecentlyTouchedListComponent } from '../patient/home/recently-touched-list/recently-touched-list.component';
import { LoaderService } from '../services/loader.service';
import { AreYouSureModalComponent } from './are-you-sure-modal/are-you-sure-modal.component';
import { PrimaryChartComponent } from './charts/primary-chart/primary-chart.component';
import { AlertResolutionModalComponent } from './components/alert-resolution-modal/alert-resolution-modal.component';
import { TimezonePickerComponent } from './components/timezone-picker/timezone-picker.component';
import { ClientContactListComponent } from './components/client-detail/client-contact-list/client-contact-list.component';
import { ClientDemographicsComponent } from './components/client-detail/client-demographics/client-demographics.component';
import { SetAwvEmailTemplateComponent } from './components/client-detail/client-demographics/set-awv-email-template/set-awv-email-template.component';
import { SetMainProviderDialogComponent } from './components/client-detail/client-demographics/set-main-provider-dialog/set-main-provider-dialog.component';
import { SetUpRatesComponent } from './components/client-detail/client-demographics/set-up-rates/set-up-rates.component';
import { SurveyConfComponent } from './components/client-detail/client-demographics/survey-conf/survey-conf.component';
import { ClientDeactivationComponent } from './components/client-detail/client-deactivation/client-deactivation.component';
import { ClientDepartmentListComponent } from './components/client-detail/client-department-list/client-department-list.component';
import { ClientEMRPracticeInfoComponent } from './components/client-detail/client-emrpractice-info/client-emrpractice-info.component';
import { SearchMedicareGeoComponent } from './components/client-detail/search-medicare-geo/search-medicare-geo.component';
import { ClinicalTimeSaveFormComponent } from './components/clinical-time-save-form/clinical-time-save-form.component';
import { CcmCarePlanPickerComponent } from './components/ccm-care-plan-picker/ccm-care-plan-picker.component';
import { CareCallGuideBaseComponent } from './components/care-call-guide/care-call-guide-base.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { CustomTooltipComponent } from './components/custom-tooltip/custom-tooltip.component';
import { DemographicsComponent } from './components/demographics/demographics.component';
import { DeviceOrderRequestTableComponent } from './components/device-order-request-table/device-order-request-table.component';
import { CallSignalIndicatorComponent } from './components/call-signal-indicator/call-signal-indicator.component';
import { DialComponent } from './components/dial/dial.component';
import { DxSelectComponent } from './components/dx-select/dx-select.component';
import { AthenaSelectorComponent } from './components/emr-components/athena-selector/athena-selector.component';
import { ElationSelectorComponent } from './components/emr-components/elation-selector/elation-selector.component';
import { EmrBaseSelectorComponent } from './components/emr-components/emr-base-selector/emr-base-selector.component';
import { PracticeFusionSelectorComponent } from './components/emr-components/practice-fusion-selector/practice-fusion-selector.component';
import { GoogleReviewButtomComponent } from './components/google-review-buttom/google-review-buttom.component';
import { IframeSanitazerComponent } from './components/iframe-sanitazer/iframe-sanitazer.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { LicenseComponent } from './components/license/license.component';
import { LoadingComponent } from './components/loading/loading.component';
import { PracticeInvoicesReportComponent } from './components/practice-invoices-report/practice-invoices-report.component';
import { ProviderSelectorListComponent } from './components/provider-selector-list/provider-selector-list.component';
import { ScrollLoaderComponent } from './components/scroll-loader/scroll-loader.component';
import { SearchDeviceComponent } from './components/search-device/search-device.component';
import { SearchNihComponent } from './components/search-nih/search-nih.component';
import { SearchNpiComponent } from './components/search-npi/search-npi.component';
import { SearchPatientComponent } from './components/search-patient/search-patient.component';
import { SimplePaginatorComponent } from './components/simple-paginator/simple-paginator.component';
import { SupplyEstimateComponent } from './components/supply-estimate/supply-estimate.component';
import { TaskDetailComponent } from './components/task-history/components/task-detail/task-detail.component';
import { TaskNotesComponent } from './components/task-history/components/task-notes/task-notes.component';
import { TaskHistoryComponent } from './components/task-history/task-history.component';
import { TermsPageComponent } from './components/terms-page/terms-page.component';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { ValidatorCodeComponent } from './components/validator-code/validator-code.component';
import { BugReportDialogComponent } from './dialogs/bug-report-dialog/bug-report-dialog.component';
import { CallPatientDialogComponent } from './dialogs/call-patient-dialog/call-patient-dialog.component';
import { BenefitsCheckResultDialogComponent } from './benefits-check/benefits-check-result-dialog.component';
import { ClinicalNoteReminderDialogComponent } from './dialogs/clinical-note-reminder-dialog/clinical-note-reminder-dialog.component';
import { EmailPatientDialogComponent } from './dialogs/email-patient-dialog/email-patient-dialog.component';
import { EmrMetaDialogComponent } from './dialogs/emr-meta-dialog/emr-meta-dialog.component';
import { EmrPracticeInfoDialogComponent } from './dialogs/emr-practice-info-dialog/emr-practice-info-dialog.component';
import { SearchPatientContentDialogComponent } from './dialogs/search-patient-content-dialog/search-patient-content-dialog.component';
import { SendFaxDialogComponent } from './dialogs/send-fax-dialog/send-fax-dialog.component';
import { SurveyDialogComponent } from './dialogs/survey-dialog/survey-dialog.component';
import { UploadReturnLabelDialogComponent } from './dialogs/upload-return-label-dialog/upload-return-label-dialog.component';
import { ContextMenuDirective } from './directives/context-menu.directive';
import { GreenMeasuresDirective } from './directives/green-measures.directive';
import { PhoneFormaterDirective } from './directives/phone-formater.directive';
import { IconSnackbarComponent } from './icon-snackbar/icon-snackbar.component';
import { ReportSnackbarComponent } from './report-snackbar/report-snackbar.component';
import { MrnInputComponent } from './mrn-input/mrn-input.component';
import { NewDeviceModalComponent } from './new-device-modal/new-device-modal.component';
import { ProfilePhotoPipe } from './pipes/profile-photo.pipe';
import { ClientAbbreviationPipe } from './pipes/client-abbreviation.pipe';
import { DateTimeWelbyCustomPipe } from './pipes/date-time-custom.pipe';
import { PatientFullnamePipe } from './pipes/patient-fullname.pipe';
import { PatientNamePipe } from './pipes/patient-name.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { RedirectModalComponent } from './redirect-modal/redirect-modal.component';
import { StripeFormComponent } from './stripe-form/stripe-form.component';
import { VitalMeasurementComponent } from './templates/vital-measurement/vital-measurement.component';
import { TimeTrackingModalComponent } from './time-tracking-modal/time-tracking-modal.component';
import { MultiThumbSliderComponent } from './components/multi-thumb-slider/multi-thumb-slider.component';
import { TwilioClientConfigDialogComponent } from './components/client-detail/client-demographics/twilio-client-config-dialog/twilio-client-config-dialog.component';
// shared module here is designed to import all of our shared UI
// features where we can just inject this module directly into other components.

const components = [
  BenefitsCheckResultDialogComponent,
  CareCallGuideBaseComponent,
  NotificationsPanelComponent,
  ShellComponent,
  NewDeviceModalComponent,
  AreYouSureModalComponent,
  StripeFormComponent,
  SimplePaginatorComponent,
  SendFaxDialogComponent,
  TimeTrackingModalComponent,
  ClinicalTimeSaveFormComponent,
  CcmCarePlanPickerComponent,
  CallPatientDialogComponent,
  SurveyDialogComponent,
  MessageDialogComponent,
  ScheduleMessageDialogComponent,
  VitalMeasurementComponent,
  PrimaryChartComponent,
  TermsPageComponent,
  LicenseComponent,
  SearchPatientComponent,
  DxSelectComponent,
  SearchNihComponent,
  EMRSearchComponent,
  EmailPatientDialogComponent,
  BugReportDialogComponent,
  SearchPatientContentDialogComponent,
  ClientContactListComponent,
  ClientDeactivationComponent,
  ClientDepartmentListComponent,
  ClientDemographicsComponent,
  ClientEMRPracticeInfoComponent,
  TaskHistoryComponent,
  TaskDetailComponent,
  TaskNotesComponent,
  UserSearchComponent,
  AthenaSelectorComponent,
  PracticeFusionSelectorComponent,
  EmrBaseSelectorComponent,
  ProviderSelectorListComponent,
  DeviceOrderRequestTableComponent,
  IframeSanitazerComponent,
  ValidatorCodeComponent,
  LanguageSelectorComponent,
  AddProvidersComponent,
  SearchDeviceComponent,
  LoadingComponent,
  DemographicsComponent,
  SearchNpiComponent,
  ContextMenuComponent,
  SearchMedicareGeoComponent,
  SetUpRatesComponent,
  ScrollLoaderComponent,
  PracticeInvoicesReportComponent,
  RecentlyTouchedListComponent,
  MultiThumbSliderComponent,
  DialComponent,
  CallSignalIndicatorComponent,
  TimezonePickerComponent,
  SupplyEstimateComponent,
];

const modules = [
  CommonModule,
  DragDropModule,
  LayoutModule,
  FlexLayoutModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  HttpClientModule,
  CKEditorModule,
  NgSelectModule,
  AngularMaterialModule,
];
const directives = [PhoneFormaterDirective, GreenMeasuresDirective, ContextMenuDirective];
const pipes = [PatientNamePipe, DateTimeWelbyCustomPipe, PatientFullnamePipe, ReplacePipe, ClientAbbreviationPipe, TimeAgoPipe, ProfilePhotoPipe];

@NgModule({
  declarations: [
    ...components,
    ...directives,
    ...pipes,
    ClinicalNoteReminderDialogComponent,
    EmrMetaDialogComponent,
    EmrPracticeInfoDialogComponent,
    RedirectModalComponent,
    ElationSelectorComponent,
    IframeSanitazerComponent,
    GoogleReviewButtomComponent,
    CustomTooltipComponent,
    SurveyConfComponent,
    TwilioClientConfigDialogComponent,
    AlertResolutionModalComponent,
    SetMainProviderDialogComponent,
    SearchNpiComponent,
    ScrollLoaderComponent,
    SetAwvEmailTemplateComponent,
    UploadReturnLabelDialogComponent,
    MrnInputComponent,
    IconSnackbarComponent,
    ReportSnackbarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    DragDropModule,
    LayoutModule,
    MatStepperModule,
    HttpClientModule,
    CKEditorModule,
    NgSelectModule,
    JoyrideModule,
    AngularMaterialModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    DragDropModule,
    LayoutModule,
    MatStepperModule,
    HttpClientModule,
    CKEditorModule,
    NgSelectModule,
    JoyrideModule,
    AngularMaterialModule,
    MrnInputComponent,
    ...components,
    ...pipes,
    ...directives,
  ],
  providers: [LoaderService, DateTimeWelbyCustomPipe, PatientNamePipe, PatientFullnamePipe],
})
export class SharedModule {}
